module.exports = __webpack_public_path__ + "img/data-pinjaman-active.0e85c3a5.svg";